import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const laboratoryAssessmentService = {
    LoadData,
    SaveData,
    LoadMMALabData,
    SaveMMALabData,
    LoadRenalLabData,
    SaveRenalLabData,
    LoadOtherLabData,
    SaveOtherLabData
};
function LoadData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/laboratoryAssessment/GetLabAssessmentData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/laboratoryAssessment/SaveLabAssessmentData", payload);
}

function LoadMMALabData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/laboratoryAssessment/GetMMALabAssessmentData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveMMALabData(payload) {
    return WebServiceWrapper.Post("/laboratoryAssessment/SaveMMALabAssessmentData", payload);
}
function LoadRenalLabData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/laboratoryAssessment/GetRenalLabAssessmentData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveRenalLabData(payload) {
    return WebServiceWrapper.Post("/laboratoryAssessment/SaveRenalLabAssessmentData", payload);
}

function LoadOtherLabData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/laboratoryAssessment/GetOtherLabAssessmentData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveOtherLabData(payload) {
    return WebServiceWrapper.Post("/laboratoryAssessment/SaveOtherLabAssessmentData", payload);
}